import { Layers } from "lucide-react";
import CrudManager, { slugify } from "@/components/admin/CrudManager";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import ImageUpload from "@/components/admin/ImageUpload";
import { ADMIN } from "@/constants/testIds";

const DEFAULT = { name: "", slug: "", description: "", image: "", order: 0, published: true };

export default function AdminCategories() {
  return (
    <CrudManager
      title="Categories"
      subtitle="Manage catalogue categories (Men's Wear, Women's Ethnic, Kids, etc.)."
      endpoint="/admin/categories"
      defaultItem={DEFAULT}
      testId={ADMIN.categoriesList}
      listRender={(c) => (
        <div className="flex items-center gap-4">
          <div className="h-14 w-14 rounded-sm bg-secondary overflow-hidden shrink-0">
            {c.image ? <img src={c.image} alt={c.name} className="w-full h-full object-cover" /> : <div className="w-full h-full flex items-center justify-center text-foreground/40"><Layers size={16} /></div>}
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-[0.65rem] tracking-widest uppercase text-gold">Category</p>
            <p className="mt-0.5 font-serif text-lg text-foreground truncate">{c.name}</p>
            <p className="text-xs text-foreground/60 truncate">{c.description}</p>
          </div>
        </div>
      )}
      formRenderer={(v, patch) => (
        <>
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <Label>Category Name</Label>
              <Input className="mt-2 rounded-sm" value={v.name} onChange={(e) => patch({ name: e.target.value, slug: v.slug || slugify(e.target.value) })} />
            </div>
            <div>
              <Label>Slug</Label>
              <Input className="mt-2 rounded-sm" value={v.slug} onChange={(e) => patch({ slug: slugify(e.target.value) })} />
            </div>
          </div>
          <div>
            <Label>Description</Label>
            <Textarea className="mt-2 rounded-sm" value={v.description} onChange={(e) => patch({ description: e.target.value })} />
          </div>
          <ImageUpload label="Category Image" value={v.image} onChange={(u) => patch({ image: u })} />
          <div className="grid md:grid-cols-2 gap-4 items-end">
            <div>
              <Label>Display Order</Label>
              <Input type="number" className="mt-2 rounded-sm" value={v.order} onChange={(e) => patch({ order: parseInt(e.target.value) || 0 })} />
            </div>
            <label className="flex items-center gap-3 p-3 rounded-sm border border-border/60 bg-secondary/40 cursor-pointer">
              <Switch checked={v.published} onCheckedChange={(c2) => patch({ published: c2 })} />
              <span className="text-sm">Published</span>
            </label>
          </div>
        </>
      )}
    />
  );
}
